import { render, staticRenderFns } from "./adInvoicNumber.vue?vue&type=template&id=2840d1fc&scoped=true"
import script from "./adInvoicNumber.vue?vue&type=script&lang=js"
export * from "./adInvoicNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840d1fc",
  null
  
)

export default component.exports